import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Box, Drawer, Grid, Header } from '~/components/blocks';
import { newPatientFromCheckinEntryDrawerState } from '~/state/patient/atoms';

import { NewPatientPanel } from './NewPatientPanel';
import { useFetchCheckinEntry } from './use-fetch-checkin_entry';

export const NewPatientFromCheckinEntryDrawer = () => {
  const { isOpen, checkinEntry, handleTransitionEnd } = useFetchCheckinEntry();
  const resetState = useResetAtom(newPatientFromCheckinEntryDrawerState);

  const handleClose = useCallback(() => {
    resetState();
  }, [resetState]);

  if (!checkinEntry) {
    return null;
  }

  return (
    <Drawer open={isOpen} onClose={handleClose} onTransitionEnd={handleTransitionEnd}>
      <Box position="relative" overflow="hidden" height="100%">
        <Grid height="100%" gridTemplateRows="min-content 1fr min-content" overflow="hidden">
          <Header attached="drawer">患者登録</Header>
          <NewPatientPanel checkinEntry={checkinEntry} />
        </Grid>
      </Box>
    </Drawer>
  );
};
